import { render, staticRenderFns } from "./ExamSpecialReport.vue?vue&type=template&id=89695cd2&"
import script from "./ExamSpecialReport.vue?vue&type=script&lang=js&"
export * from "./ExamSpecialReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports